import React from "react";
import pattern_16 from "../assets/images/background/pattern-16.png";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import termsOgImage from "../assets/images/main-slider/software-erp-development-hero.png";

const Terms_and_Conditions = () => {
  const canonical = "https://www.swiftmazetech.com/terms-and-conditions/";
  const ogImage = `https://www.swiftmazetech.com${termsOgImage}`;
  const description = "Review SwiftMaze Tech terms and conditions for service usage, payments, responsibilities, and legal policies.";
  return (
    <>
      <Helmet>
        <title>Terms and Conditions | SwiftMaze Tech</title>
        <meta
          name="description"
          content={description}
        />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href={canonical} />
        <meta property="og:title" content="Terms and Conditions | SwiftMaze Tech" />
        <meta property="og:description" content={description} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={ogImage} />
        <meta property="og:url" content={canonical} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Terms and Conditions | SwiftMaze Tech" />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={ogImage} />
      </Helmet>
      <section className="page-title">
        <div
          className="pattern-layer-one"
          style={{ backgroundImage: `url(${pattern_16})` }}
        ></div>
        <div className="auto-container">
          <h2>Terms & Conditions</h2>
          <ul className="page-breadcrumb">
            <li><Link to="/">Home</Link></li>
            <li>Terms & Conditions</li>
          </ul>
        </div>
      </section>

      <section className="about-section">
        <div className="auto-container">
          <div className="sec-title">
            <div className="title">Terms & Conditions</div>
            <h2>Agreement for Using Our Services</h2>
          </div>

          <div className="privacy-content">
            <h4>Acceptance of Terms</h4>
            <p>
              By accessing or using the SwiftMaze Tech website and services, you
              agree to be bound by these Terms & Conditions. If you do not agree,
              please do not use our services.
            </p>

            <h4>Services</h4>
            <ul>
              <li>Website development and maintenance</li>
              <li>SEO and digital marketing services</li>
              <li>Web scraping, automation, and custom software solutions</li>
              <li>Consultation and technical support</li>
            </ul>

            <h4>Payments & Billing</h4>
            <ul>
              <li>All payments are processed securely through third-party gateways such as Razorpay, PhonePe, Paytm, or others.</li>
              <li>Prices are communicated before order confirmation.</li>
              <li>Payments must be completed in full before service delivery unless otherwise agreed.</li>
              <li>We do not store card or UPI details on our servers.</li>
            </ul>

            <h4>User Responsibilities</h4>
            <ul>
              <li>Provide accurate information during transactions.</li>
              <li>Do not misuse or attempt to exploit our services.</li>
              <li>Maintain confidentiality of login credentials.</li>
            </ul>

            <h4>Intellectual Property</h4>
            <ul>
              <li>All website content, code, and designs belong to SwiftMaze Tech unless stated otherwise.</li>
              <li>Unauthorized copying or redistribution is prohibited.</li>
            </ul>

            <h4>Limitation of Liability</h4>
            <ul>
              <li>We are not liable for indirect or consequential losses.</li>
              <li>Service delays caused by third-party platforms are not our responsibility.</li>
              <li>Maximum liability is limited to the amount paid for the service.</li>
            </ul>

            <h4>Termination</h4>
            <p>
              We reserve the right to suspend or terminate services if these
              terms are violated.
            </p>

            <h4>Governing Law</h4>
            <p>
              These terms are governed by the laws of India. Any disputes shall
              be subject to Indian jurisdiction.
            </p>

            <h4>Contact</h4>
            <p>
              For any questions regarding these terms, please contact us through
              our website.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Terms_and_Conditions;
